import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";

import EpisodesPage from "./pages/EpisodesPage";
import CharactersPage from "./pages/CharactersPage";
import LocationsPage from "./pages/LocationsPage";
import Header from "./components/Header";
import Footer from "./components/Footer";

function NotFoundPage() {
  return (
    <div className="mx-auto max-w-2xl px-4 py-24 text-center">
      <p className="text-6xl font-bold text-portal-400">404</p>
      <h1 className="mt-4 text-2xl font-semibold text-white">
        This dimension does not exist
      </h1>
      <p className="mt-2 text-slate-400">
        Nothing is served at this address. Try one of the three sections.
      </p>
      <Link
        to="/"
        className="mt-8 inline-block rounded-lg bg-portal-400 px-5 py-2.5 font-medium text-space-950 transition hover:bg-portal-200"
      >
        Back to episodes
      </Link>
    </div>
  );
}

function App() {
  return (
    <Router>
      <div className="flex min-h-screen flex-col bg-space-900">
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<EpisodesPage />} />
            <Route path="/characters" element={<CharactersPage />} />
            <Route path="/locations" element={<LocationsPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
